import React from 'react';
import { Container, Row, Col, Accordion } from 'react-bootstrap';

const HelpPage: React.FC = () => {
  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col xs={12} md={10} lg={8}>
          <div className="text-center mb-5">
            <h2 className="display-5 mb-3">❓ Help & Support</h2>
            <p className="lead text-muted">
              Find answers to common questions and get the help you need
            </p>
          </div>
          
          <Accordion defaultActiveKey="0">
            <Accordion.Item eventKey="0">
              <Accordion.Header>🚀 Getting Started</Accordion.Header>
              <Accordion.Body>
                <p>
                  Welcome to Pouncer! This application is currently in development and serves 
                  as a demonstration of modern full-stack web development practices.
                </p>
                <p>
                  <strong>Quick Start:</strong>
                </p>
                <ul>
                  <li>Navigate using the top menu bar</li>
                  <li>Test backend connectivity on the homepage</li>
                  <li>Explore different sections to see the features</li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>
            
            <Accordion.Item eventKey="1">
              <Accordion.Header>🛠️ Technical Support</Accordion.Header>
              <Accordion.Body>
                <p>
                  If you encounter any issues while using the application, here are some 
                  troubleshooting steps:
                </p>
                <ul>
                  <li><strong>Connection Issues:</strong> Check that the backend service is running</li>
                  <li><strong>Browser Issues:</strong> Try refreshing the page or clearing cache</li>
                  <li><strong>Error Messages:</strong> Check the browser console for detailed error information</li>
                </ul>
                <div className="alert alert-info mt-3">
                  <strong>💡 Tip:</strong> The application includes comprehensive health checks 
                  and error handling for most common scenarios.
                </div>
              </Accordion.Body>
            </Accordion.Item>
            
            <Accordion.Item eventKey="2">
              <Accordion.Header>💻 System Requirements</Accordion.Header>
              <Accordion.Body>
                <p>
                  To ensure the best experience with Pouncer, please make sure your system 
                  meets the following requirements:
                </p>
                <div className="row">
                  <div className="col-md-6">
                    <h6>Browser Requirements:</h6>
                    <ul>
                      <li>Chrome 90+ (recommended)</li>
                      <li>Firefox 88+</li>
                      <li>Safari 14+</li>
                      <li>Edge 90+</li>
                    </ul>
                  </div>
                  <div className="col-md-6">
                    <h6>System Requirements:</h6>
                    <ul>
                      <li>JavaScript enabled</li>
                      <li>Internet connection</li>
                      <li>Modern device (desktop/tablet/mobile)</li>
                    </ul>
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            
            <Accordion.Item eventKey="3">
              <Accordion.Header>📞 Contact Information</Accordion.Header>
              <Accordion.Body>
                <p>
                  Need additional support or have questions about the Pouncer application?
                </p>
                <div className="row">
                  <div className="col-md-6">
                    <h6>Development Resources:</h6>
                    <ul>
                      <li>GitHub Repository (source code)</li>
                      <li>Documentation portal</li>
                      <li>Issue tracking system</li>
                    </ul>
                  </div>
                  <div className="col-md-6">
                    <h6>Community:</h6>
                    <ul>
                      <li>Developer forums</li>
                      <li>Community discussions</li>
                      <li>Feature requests</li>
                    </ul>
                  </div>
                </div>
                <div className="alert alert-success mt-3">
                  <strong>🤝 Contributing:</strong> This is an open-source project. 
                  Contributions and feedback are always welcome!
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>
      </Row>
    </Container>
  );
};

export default HelpPage;
